import LoginModal, { LoginData } from './LoginModal';
import Authorization, { LoginSuccessResponse, LoginResponse } from './Authorization';
import TemsPolicy from './TemsPolicy';

interface LoginViewFailedResponse  {
    success: false,
    message: string
}

type LoginViewResponse = LoginSuccessResponse | LoginViewFailedResponse;

export default class AuthorizationView {
    private notAvailableErrorMessage: string;
    private readonly loginModal: LoginModal;
    private readonly authorization: Authorization;

    public constructor(authorization: Authorization, loginModal: LoginModal, notAvailableErrorMessage: string) {
        this.authorization = authorization;
        this.loginModal = loginModal;
        this.notAvailableErrorMessage = notAvailableErrorMessage;
    }

    public showLogin(): Promise<void> {
        return this.acquireLoginResponse().then((loginResponse) => {
            if (loginResponse.success) {
                this.loginModal.closeModal();
            } else if (loginResponse.success === false) {
                this.loginModal.showError(loginResponse.message);
                return this.showLogin();
            }
        });
    }

    public getTokenForPolicy(...policies: TemsPolicy[]): Promise<LoginSuccessResponse> {
        var login = this.demandLogin(
            this.authorization.autoLogin(policies).then((r) => this.mapLoginResponseToLoginViewResponse(r)),
            policies
        );
        login.catch(e => {
            console.error(e);
        });
        return login;
    }


    private demandLogin(previous: Promise<LoginViewResponse>, policies: TemsPolicy[]): Promise<LoginSuccessResponse> {
        return previous.then((response) => {
            return (response.success)
                ? response
                : this.acquireLoginResponse().then(loginResponse => {
                    if (loginResponse.success) {
                        if (this.authorization.authorize(...policies)) {
                            this.loginModal.closeModal();
                            return Promise.resolve(<LoginSuccessResponse>loginResponse);
                        } else {
                            this.loginModal.showError("Access denied");
                        }
                    } else if (loginResponse.success === false) {
                        this.loginModal.showError(loginResponse.message);
                    }
                    const failedResponse: LoginViewFailedResponse = { success: false, message: '' };
                    return this.demandLogin(Promise.resolve(failedResponse), policies);
                });
        });
    }

    private acquireLoginResponse(): Promise<LoginViewResponse> {
        return this.loginModal.requestLoginData().then((loginData: LoginData) => {
            return this.sendLoginRequest(loginData.userName, loginData.password);
        });
    }

    private sendLoginRequest(userName: string, password: string): Promise<LoginViewResponse> {
        return this.authorization.login(userName, password).then((r) => this.mapLoginResponseToLoginViewResponse(r));
    }
    private mapLoginResponseToLoginViewResponse(response: LoginResponse): LoginViewResponse {
        if (response.success == false) {
            return <LoginViewFailedResponse>{
                success: false,
                message: (response.rawResponse) ? response.rawResponse.Message : this.notAvailableErrorMessage
            };
        }

        return response;
    }
}